import { GlobalRouter } from '@okapi/router-react';
import { combineReducers } from 'redux';
import { createReducer as createRouterReducer } from '@okapi/router-connect';
import { createReducer as createCookieReducer } from 'isomorphic-redux-cookie-middleware';
import { createReducer } from 'typesafe-actions';
import { LogLevel } from 'common/constants';
import { createReducer as createLayersReducer } from './header-middleware/reducer';
import { Layers } from './header-middleware/types';
import { featuresReducer } from '../features';

export const rootReducer = (
  host: string,
  globalRouter: GlobalRouter,
  cookie: string,
  layers: Layers,
  isBot: boolean,
  userAgent: string,
  env: Env,
  disableComparisons: boolean,
  uuid?: string,
) =>
  combineReducers({
    carousel: featuresReducer,
    router: createRouterReducer(globalRouter),
    host: createReducer(host),
    cookies: createCookieReducer(cookie),
    layers: createLayersReducer(layers),
    isBot: createReducer(isBot),
    env: createReducer(env),
    userAgent: createReducer(userAgent),
    disableComparisons: createReducer(disableComparisons),
    ...(uuid ? { uuid: createReducer(uuid || '') } : {}),
  });

export type Env = {
  API_KEY?: string;
  API_KEY_BACKEND?: string;
  ENV_TOGGLE: boolean;
  LOG_LEVEL?: LogLevel;
  ORCHESTRATOR_BACKEND_HOST?: string;
  ORCHESTRATOR_HOST: string;
  ORCHESTRATOR_HOST_KZ?: string;
  PRODUCTS_COMPARE_LISTS_LIMIT?: number;
  PRODUCTS_COMPARE_LIST_LIMIT?: number;
  PRODUCTS_COMPARE_ORCHESTRATOR_BACKEND_HOST?: string;
  PRODUCTS_COMPARE_ORCHESTRATOR_HOST?: string;
  PRODUCTS_COMPARE_ORCHESTRATOR_HOST_KZ?: string;
  USE_CREDENTIALS: boolean;
  USE_GROUP_RATINGS: boolean;
  requestID: string;
};
